// extracted by mini-css-extract-plugin
export default {"step-payment-check-section-root":"step-payment-check-section-root___HaIVo"};